import { trim } from 'lodash';
import { STAFF_LIKE_ACCOUNT_TYPES } from 'constants/optionLists';
import { Contact } from 'types/contact';

export default function makeAccessLink(email: string, accountTypes: Contact['accountTypes']) {
  const emailSanit = trim(email) || '';
  let homeURL = 'https://onthemove-35981.firebaseapp.com';

  if (STAFF_LIKE_ACCOUNT_TYPES.some((type) => accountTypes?.includes(type))) {
    homeURL = 'https://staff.onthemove.com';
  } else if (accountTypes?.includes('Client')) {
    homeURL = 'https://clients.onthemove.com';
  } else if (accountTypes?.includes('Talent')) {
    homeURL = 'https://talent.onthemove.com';
  }

  const url = `${homeURL}/account/register/?account=${emailSanit}`;
  const message = /* html */ `<b>If you have not done so already</b>, Set your password at this link:<br />
  <a href="${url}">${url}</a><br /><br />

  Once you have set your password, you may return to the app at this link:<br /> 
  <a href="${homeURL}">${homeURL}</a>`;

  return { url, message };
}
